<template>
  <div class="create-project-block container text-uppercase my-3">
    <h6 class="create-project-header d-flex justify-content-center">Select Project Type</h6>
    <button
      type="button"
      class="wf-modal-button-close btn button-full"
      @click="$modal.hide('project-type-selection-modal')"
    >
      <span 
        class="png-icon png-icon-icons-symbols--k-txtclose"
        aria-label="Close modal" 
      />
    </button>
    <div class="my-3">
      <p>{{ $resourceString["myProject.ProjectTypeSelection.Description"] }}</p>

      <div class="row mt-3">
        <div class="col-md-6 mb-3">
          <div class="form-check custom-radio h-100">
            <input 
              class="form-check-input" 
              type="radio" 
              name="projectType" 
              id="personalProject" 
              value="personal"
              v-model="selectedType" 
            />
            <label class="form-check-label" for="personalProject">
              Create Personal Project
            </label>
          </div>
        </div>

        <div class="col-md-6 mb-3" v-if="isAdmin">
          <div class="form-check custom-radio h-100">
            <input 
              class="form-check-input" 
              type="radio" 
              name="projectType" 
              id="brandProject" 
              value="brand"
              v-model="selectedType" 
            />
            <label class="form-check-label" for="brandProject">
              Create Brand Project
            </label>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 text-center">
          <button
            class="btn btn-success"
            @click="confirmSelection"
            :disabled="!selectedType"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["isAdmin"],
  data() {
    return {
      selectedType: null,
    };
  },
  methods: {
    ...mapActions({
      setSelectedProjectCategory: "myProject/setSelectedProjectCategory",
      setVirtualTrayType: "myTray/setVirtualTrayType",
    }),
    selectProjectType(type) {
      this.selectedType = type;
      if (type === "brand") {
        this.setVirtualTrayType("Brand");
      } else {
        this.setVirtualTrayType("Active");
      }
    },
    confirmSelection() {
      if (this.selectedType) {
        this.setSelectedProjectCategory(this.selectedType === "brand");
        this.$emit("projectSelected", this.selectedType);
        this.$modal.hide("project-type-selection-modal");
      }
    },
  },
  mounted() {
    console.log("Received isAdmin Prop:", this.isAdmin);
  },
};
</script>
<style scoped>
.custom-radio {
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
}

.custom-radio:hover {
  background-color: #f8f9fa;
}

.form-check-input:checked + .form-check-label {
  font-weight: bold;
}

.custom-radio input:checked ~ .form-check-label {
  color: #4a5057;
}

.form-check-input:checked ~ .custom-radio {
  border-color: #007bff;
  background-color: rgba(0, 123, 255, 0.1);
}
</style>